var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      { staticClass: "navbar" },
      [
        _c("loading", {
          attrs: { active: _vm.isLoading, loader: "dots" },
          on: {
            "update:active": function ($event) {
              _vm.isLoading = $event
            },
          },
        }),
        _c(
          "div",
          {
            staticClass: "toggle-sm-sidebar",
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.openSmSidebar.apply(null, arguments)
              },
            },
          },
          [_c("span"), _c("span"), _c("span")]
        ),
        _c(
          "div",
          {
            staticClass: "toggle-sidebar",
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.openSidebar.apply(null, arguments)
              },
            },
          },
          [_c("span"), _c("span"), _c("span")]
        ),
        _c("BreadCrumbs", { staticClass: "showBreadCrumbs" }),
        _c("div", { staticClass: "function-list" }),
        _c("button", { staticClass: "account-btn" }, [
          _c("img", {
            attrs: { src: require("@/assets/img/head2.png"), alt: "" },
          }),
          _vm._v(" " + _vm._s(_vm.userName) + " "),
          _c("i", {
            staticClass: "fas fa-cog",
            staticStyle: { "margin-left": "5px" },
          }),
          _c("ul", [
            _c("li", [
              _c(
                "a",
                {
                  attrs: { href: "javascript: void(0)" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.openChangePasswordModal.apply(null, arguments)
                    },
                  },
                },
                [_vm._v("變更密碼")]
              ),
              _c(
                "a",
                {
                  attrs: { href: "javascript: void(0)" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.logout.apply(null, arguments)
                    },
                  },
                },
                [_vm._v("登出")]
              ),
            ]),
          ]),
        ]),
        _c(
          "div",
          {
            staticClass: "function-content",
            class: { open: _vm.currentFunctionContent != "0" },
          },
          [
            _c(
              "div",
              {
                staticClass: "function-content-close-btn",
                on: {
                  click: function ($event) {
                    _vm.currentFunctionContent = "0"
                  },
                },
              },
              [_c("i", { staticClass: "fas fa-times" })]
            ),
            _vm.currentFunctionContent == "1"
              ? _c("div", { staticClass: "function-content-inner" }, [
                  _c("div", { staticClass: "function-title" }, [
                    _vm._v("系統說明"),
                  ]),
                  _vm._m(0),
                ])
              : _vm._e(),
            _vm.currentFunctionContent == "2"
              ? _c("div", { staticClass: "function-content-inner" }, [
                  _c("div", { staticClass: "function-title" }, [
                    _vm._v("設定"),
                  ]),
                  _vm._m(1),
                ])
              : _vm._e(),
            _vm.currentFunctionContent == "3"
              ? _c("div", { staticClass: "function-content-inner" }, [
                  _c("div", { staticClass: "function-title" }, [
                    _vm._v("意見反應"),
                  ]),
                  _vm._m(2),
                ])
              : _vm._e(),
          ]
        ),
      ],
      1
    ),
    _c(
      "div",
      {
        staticClass: "modal fade",
        attrs: {
          id: "changePasswordByOneself",
          tabindex: "-1",
          "aria-labelledby": "exampleModalLabel",
          "aria-hidden": "true",
          "data-backdrop": "static",
        },
      },
      [
        _c("img", {
          staticClass: "password_bg",
          attrs: { src: require("@/assets/img/password_bg.png"), alt: "" },
        }),
        _c(
          "div",
          { staticClass: "modal-dialog modal-dialog-centered" },
          [
            _c("ValidationObserver", {
              ref: "changePassword",
              staticClass: "modal-content",
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function ({ handleSubmit, reset }) {
                    return [
                      _c(
                        "form",
                        {
                          on: {
                            submit: function ($event) {
                              $event.preventDefault()
                              return handleSubmit(_vm.changePassword)
                            },
                            reset: function ($event) {
                              $event.preventDefault()
                              return reset.apply(null, arguments)
                            },
                          },
                        },
                        [
                          _c("img", {
                            staticClass: "password_bg_02",
                            attrs: {
                              src: require("@/assets/img/password_bg_02.png"),
                              alt: "",
                            },
                          }),
                          _c("div", { staticClass: "modal-header" }, [
                            _c("span", [_vm._v("變更密碼")]),
                          ]),
                          _c("div", { staticClass: "modal-body" }, [
                            _vm.showTip
                              ? _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      "margin-bottom": "20px",
                                      color: "red",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " 您的密碼已九十天未變更，或是初次登入"
                                    ),
                                    _c("br"),
                                    _vm._v(
                                      " 為保障您的帳戶安全，請盡速完成密碼變更。 "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _c(
                              "div",
                              { staticClass: "form-group form" },
                              [
                                _c("label", { attrs: { for: "" } }, [
                                  _c(
                                    "span",
                                    { staticStyle: { color: "#ff0000" } },
                                    [_vm._v("*")]
                                  ),
                                  _vm._v(" 請輸入舊密碼 "),
                                ]),
                                _c("ValidationProvider", {
                                  attrs: { rules: "required", name: "舊密碼" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function ({ errors }) {
                                          return [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    _vm.changePasswordData
                                                      .CurrentPassword,
                                                  expression:
                                                    "changePasswordData.CurrentPassword",
                                                },
                                              ],
                                              attrs: { type: "password" },
                                              domProps: {
                                                value:
                                                  _vm.changePasswordData
                                                    .CurrentPassword,
                                              },
                                              on: {
                                                input: function ($event) {
                                                  if ($event.target.composing)
                                                    return
                                                  _vm.$set(
                                                    _vm.changePasswordData,
                                                    "CurrentPassword",
                                                    $event.target.value
                                                  )
                                                },
                                              },
                                            }),
                                            errors[0]
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "text-danger ml-1",
                                                  },
                                                  [_vm._v(_vm._s(errors[0]))]
                                                )
                                              : _vm._e(),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "form-group" },
                              [
                                _c("label", { attrs: { for: "" } }, [
                                  _c("span", { staticClass: "mark" }, [
                                    _vm._v("*"),
                                  ]),
                                  _vm._v(" 請輸入新密碼"),
                                  _c("span", { staticClass: "mark" }, [
                                    _vm._v(
                                      "(須含大小寫英文及數字，至少12個字元)"
                                    ),
                                  ]),
                                ]),
                                _c("ValidationProvider", {
                                  attrs: {
                                    name: "新密碼",
                                    vid: "confirmation",
                                    rules: "required|password_complexity",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function ({ errors }) {
                                          return [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model.trim",
                                                  value:
                                                    _vm.changePasswordData
                                                      .NewPassword,
                                                  expression:
                                                    "changePasswordData.NewPassword",
                                                  modifiers: { trim: true },
                                                },
                                              ],
                                              attrs: { type: "password" },
                                              domProps: {
                                                value:
                                                  _vm.changePasswordData
                                                    .NewPassword,
                                              },
                                              on: {
                                                input: function ($event) {
                                                  if ($event.target.composing)
                                                    return
                                                  _vm.$set(
                                                    _vm.changePasswordData,
                                                    "NewPassword",
                                                    $event.target.value.trim()
                                                  )
                                                },
                                                blur: function ($event) {
                                                  return _vm.$forceUpdate()
                                                },
                                              },
                                            }),
                                            errors[0]
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "text-danger ml-1",
                                                  },
                                                  [_vm._v(_vm._s(errors[0]))]
                                                )
                                              : _vm._e(),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "form-group" },
                              [
                                _c("label", { attrs: { for: "" } }, [
                                  _c(
                                    "span",
                                    { staticStyle: { color: "#ff0000" } },
                                    [_vm._v("*")]
                                  ),
                                  _vm._v(" 確認新密碼 "),
                                ]),
                                _c("ValidationProvider", {
                                  attrs: {
                                    name: "確認新密碼",
                                    rules: "required|confirmed:confirmation",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function ({ errors }) {
                                          return [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model.trim",
                                                  value:
                                                    _vm.changePasswordData
                                                      .ConfirmPassword,
                                                  expression:
                                                    "changePasswordData.ConfirmPassword",
                                                  modifiers: { trim: true },
                                                },
                                              ],
                                              attrs: { type: "password" },
                                              domProps: {
                                                value:
                                                  _vm.changePasswordData
                                                    .ConfirmPassword,
                                              },
                                              on: {
                                                input: function ($event) {
                                                  if ($event.target.composing)
                                                    return
                                                  _vm.$set(
                                                    _vm.changePasswordData,
                                                    "ConfirmPassword",
                                                    $event.target.value.trim()
                                                  )
                                                },
                                                blur: function ($event) {
                                                  return _vm.$forceUpdate()
                                                },
                                              },
                                            }),
                                            errors[0]
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "text-danger ml-1",
                                                  },
                                                  [_vm._v(_vm._s(errors[0]))]
                                                )
                                              : _vm._e(),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                          ]),
                          _c("div", { staticClass: "modal-footer" }, [
                            _c(
                              "button",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: !_vm.forceChange,
                                    expression: "!forceChange",
                                  },
                                ],
                                staticClass: "btn btn-secondary",
                                attrs: {
                                  type: "reset",
                                  "data-dismiss": "modal",
                                },
                              },
                              [_vm._v(" 取消 ")]
                            ),
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-success",
                                attrs: { type: "submit" },
                              },
                              [_vm._v("儲存")]
                            ),
                          ]),
                        ]
                      ),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "function-info" }, [
      _c("div", { staticClass: "info" }, [
        _c("div", { staticClass: "info-title" }, [_vm._v("系統管理")]),
        _c("div", { staticClass: "info-desc" }, [
          _vm._v("設定使用者相關權限，安全控管系統"),
        ]),
      ]),
      _c("div", { staticClass: "info" }, [
        _c("div", { staticClass: "info-title" }, [_vm._v("招募管理")]),
        _c("div", { staticClass: "info-desc" }, [
          _vm._v(
            " 包含履歷分派、推薦、安排面談、感謝函、預聘、雇用等管理流程。 "
          ),
        ]),
      ]),
      _c("div", { staticClass: "info" }, [
        _c("div", { staticClass: "info-title" }, [_vm._v("招聘進度")]),
        _c("div", { staticClass: "info-desc" }, [
          _vm._v(
            " 透過搜尋功能，可迅速查找應徵者資料，並可註記或加入最愛清單。 "
          ),
        ]),
      ]),
      _c("div", { staticClass: "info" }, [
        _c("div", { staticClass: "info-title" }, [_vm._v("人才庫")]),
        _c("div", { staticClass: "info-desc" }, [
          _vm._v(
            " 資通電腦線上招募系統可與各人力銀行平台介接 完整建立企業人才資料庫。 "
          ),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "function-info" }, [
      _c("div", { staticClass: "info" }, [
        _c("div", { staticClass: "info-title" }, [_vm._v("色系選擇")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "function-info" }, [
      _c("div", { staticClass: "info" }, [
        _c("div", { staticClass: "info-desc" }, [
          _vm._v("感謝您撥冗提供意見反應。"),
        ]),
        _c("textarea", {
          attrs: {
            name: "",
            id: "",
            cols: "30",
            rows: "10",
            placeholder: "請與我們分享您的體驗...",
          },
        }),
        _c("button", [_vm._v("送出")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }